import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao.js"

export default [
  {
    path: "/lista-academico/",
    name: "lista-academico",
    component: () => import("@/view/calendario/ListaAcademico.vue"),
    meta: {
      title: "Lista de calendário acadêmico",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
        {
          text: "Inicial",
          disabled: false,
          to: "/",
        },
        { text: "Lista calendários", disabled: true },
      ],
    },
  },
  {
    path: "/lista-academico-data/:calendarioId",
    name: "lista-academico-data",
    component: () => import("@/view/calendario/ListaAcademicoData.vue"),
    meta: {
      title: "Lista de datas do calendário acadêmico",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
        {
          text: "Inicial",
          disabled: false,
          to: "/",
        },
        {
          text: "Lista calendários",
          disabled: false,
          to: "/lista-academico/",
        },

        { text: "Lista datas", disabled: true },
      ],
    },
  },
  {
    path: "/periodo-letivo/:calendarioId/:periodoId?",
    name: "periodo-letivo",
    component: () => import("@/view/calendario/PeriodoLetivo.vue"),
    meta: {
      title: "Períodos letivo",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb(route) {
        const calendarioId = route.params.calendarioId

        return [
          {
            text: "Inicial",
            disabled: false,
            to: "/",
          },
          {
            text: "Lista calendários",
            disabled: false,
            to: "/lista-academico/",
          },
          {
            text: "Lista de períodos letivos",
            disabled: false,
            to: `/lista-periodo-letivo/${calendarioId}`,
          },
          { text: "Período letivo", disabled: true },
        ]
      },
    },
  },
  {
    path: "/lista-periodo-letivo/:calendarioId",
    name: "lista-periodo-letivo",
    component: () => import("@/view/calendario/ListaPeriodoLetivo.vue"),
    meta: {
      title: "Lista de períodos letivos",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
        {
          text: "Inicial",
          disabled: false,
          to: "/",
        },
        {
          text: "Lista calendários",
          disabled: false,
          to: "/lista-academico/",
        },

        { text: "Lista de períodos letivos", disabled: true },
      ],
    },
  },
  {
    path: "/periodo-letivo-data/:calendarioId/:periodoLetivoId/:id?",
    name: "periodo-letivo-data",
    component: () => import("@/view/calendario/PeriodoLetivoData.vue"),
    meta: {
      title: "Períodos letivo",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb(route) {
        const calendarioId = route.params.calendarioId
        const periodoLetivoId = route.params.periodoLetivoId

        return [
          {
            text: "Inicial",
            disabled: false,
            to: "/",
          },
          {
            text: "Lista calendários",
            disabled: false,
            to: "/lista-academico/",
          },
          {
            text: "Lista de períodos letivos",
            disabled: false,
            to: `/lista-periodo-letivo/${calendarioId}`,
          },
          {
            text: "Lista de datas de períodos letivos",
            disabled: false,
            to: `/lista-periodo-letivo-data/${calendarioId}/${periodoLetivoId}`,
          },
          { text: "Período letivo data", disabled: true },
        ]
      },
    },
  },
  {
    path: "/lista-periodo-letivo-data/:calendarioId/:periodoLetivoId",
    name: "lista-periodo-letivo-data",
    component: () => import("@/view/calendario/ListaPeriodoLetivoData.vue"),
    meta: {
      title: "Lista de períodos letivos",
      caminho: "cursoconsulta", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso

      breadcrumb(route) {
        const calendarioId = route.params.calendarioId

        return [
          {
            text: "Inicial",
            disabled: false,
            to: "/",
          },
          {
            text: "Lista calendários",
            disabled: false,
            to: "/lista-academico/",
          },
          {
            text: "Lista de períodos letivos",
            disabled: false,
            to: `/lista-periodo-letivo/${calendarioId}`,
          },
          { text: "Lista de datas de períodos letivos", disabled: true },
        ]
      },
    },
  },
]
